import { ICGMBranch } from "../../../../../../store/cgmBranchesReducer";

interface IProps {
    criticalBranch: ICGMBranch;
}

export const CriticalBranchDisplay = ({ criticalBranch }: IProps) => {
    return (
        <div id={`div-cbranch-display-${criticalBranch.id}`} className="cbranch-display">
            <p id={`p-cbranch-display-a-${criticalBranch.id}`}>
                <span id={`span-cbranch-display-branchID-${criticalBranch.id}`}>Critical branch ID: </span>
                {criticalBranch.id}
            </p>
            <p id={`p-cbranch-display-b-${criticalBranch.id}`}>
                <span id={`span-cbranch-display-timeInterval-${criticalBranch.id}`}>Time interval: </span>
                {criticalBranch.timeInterval
                    .map(x => x.toString().padStart(2, "0") + ":30")
                    .join(", ")}
            </p>
            <h4 id={`h4-cbranch-criticalBranch-${criticalBranch.id}`}>Critical branch: </h4>
            <div id={`div-cbranch-critical-branch-a-${criticalBranch.id}`} className="cbranch-critical-branch">
                <p id={`p-cbranch-display-c-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-EIC-${criticalBranch.id}`}>EIC: </span>
                    {criticalBranch.criticalBranch?.eic}
                </p>
                <p id={`p-cbranch-display-bc-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-from-${criticalBranch.id}`}>From: </span>
                    {criticalBranch.criticalBranch?.node1}
                </p>
                <p id={`p-cbranch-display-d-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-to-${criticalBranch.id}`}>To: </span>
                    {criticalBranch.criticalBranch?.node2}
                </p>
                <p id={`p-cbranch-display-e-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-elementName-${criticalBranch.id}`}>Element name: </span>
                    {criticalBranch.criticalBranch?.elementName}
                </p>
                <p id={`p-cbranch-display-f-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-name-${criticalBranch.id}`}>Name: </span>
                    {criticalBranch.criticalBranch?.name}
                </p>
            </div>
            {criticalBranch.imaxFactor ? (
                <p id={`p-cbranch-display-g-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-IMaxFactor-${criticalBranch.id}`}>IMax factor: </span>
                    {criticalBranch.imaxFactor}
                </p>
            ) : (
                <p id={`p-cbranch-display-h-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-IMaxA-${criticalBranch.id}`}>IMaxA: </span>
                    {criticalBranch.imaxA}
                </p>
            )}
            <p id={`p-cbranch-display-i-${criticalBranch.id}`}>
                <span id={`span-cbranch-display-IMaxType-${criticalBranch.id}`}>IMax type: </span>
                {criticalBranch.imaxType}
            </p>
            {criticalBranch.permanentImaxFactor ? (
                <p id={`p-cbranch-display-j-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-permIMaxFactor-${criticalBranch.id}`}>Permanent IMax factor: </span>
                    {criticalBranch.permanentImaxFactor}
                </p>
            ) : (
                <p id={`p-cbranch-display-k-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-permIMaxA-${criticalBranch.id}`}>Permanent IMaxA: </span>
                    {criticalBranch.permanentImaxA}
                </p>
            )}
            {criticalBranch.temporaryImaxFactor ? (
                <p id={`p-cbranch-display-l-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-tempIMaxFactor-${criticalBranch.id}`}>Temporary IMax factor: </span>
                    {criticalBranch.temporaryImaxFactor}
                </p>
            ) : (
                <p id={`p-cbranch-display-m-${criticalBranch.id}`}>
                    <span id={`span-cbranch-display-tempIMaxA-${criticalBranch.id}`}>Temporary IMaxA: </span>
                    {criticalBranch.temporaryImaxA}
                </p>
            )}
            <p id={`p-cbranch-display-n-${criticalBranch.id}`}>
                <span id={`span-cbranch-display-FRmMw-${criticalBranch.id}`}>FrmMw: </span>
                {criticalBranch.frmMw}
            </p>
            <p id={`p-cbranch-display-o-${criticalBranch.id}`}>
                <span id={`span-cbranch-display-minRAMfactor-${criticalBranch.id}`}>Min RAM factor: </span>
                {criticalBranch.minRamFactor}
            </p>
            <p id={`p-cbranch-display-p-${criticalBranch.id}`}>
                <span id={`span-cbranch-display-CNEC-${criticalBranch.id}`}>CNEC: </span>
                {criticalBranch.cnec ? "Yes" : "No"}
            </p>
            <p id={`p-cbranch-display-r-${criticalBranch.id}`}>
                <span id={`span-cbranch-display-MNEC-${criticalBranch.id}`}>MNEC: </span>
                {criticalBranch.mnec ? "Yes" : "No"}
            </p>
            <p id={`p-cbranch-display-s-${criticalBranch.id}`}>
                <span id={`span-cbranch-display-direction-${criticalBranch.id}`}>Direction: </span>
                {criticalBranch.direction}
            </p>
            <p id={`p-cbranch-display-t-${criticalBranch.id}`}>
                <span id={`span-cbranch-display-TSOorigin-${criticalBranch.id}`}>TSO origin: </span>
                {criticalBranch.tsoOrigin}
            </p>
            <h4 id={`h4-branchDisplay-outageList-${criticalBranch.id}`} >Outages list: </h4>
            <div id={`div-cbranch-outages-${criticalBranch.id}`} className="cbranch-outages" >
                <p id={`p-cbranch-outages-a-${criticalBranch.id}`}>
                    <span id={`span-cbranch-outages-ID-${criticalBranch.id}`}>ID: </span>
                    {criticalBranch.outage?.id}
                </p>
                <p id={`p-cbranch-outages-b-${criticalBranch.id}`}>
                    <span id={`span-cbranch-outages-name-${criticalBranch.id}`}>Name: </span>
                    {criticalBranch.outage?.name}
                </p>
                <p id={`p-cbranch-outages-c-${criticalBranch.id}`}>
                    <span id={`span-cbranch-outages-location-${criticalBranch.id}`}>Location: </span>
                    {criticalBranch.outage?.location}
                </p>
                {criticalBranch.outage?.branches.map((o, index) => (
                    <div id={`div-cbranch-outages-map-${index}-${criticalBranch.id}`} key={o.key}>
                        <p id={`p-cbranch-outages-d-${index}-${criticalBranch.id}`}>
                            <span id={`cbranch-outages-from-${index}-${criticalBranch.id}`}>From: </span>
                            {o.node1}
                        </p>
                        <p id={`p-cbranch-outages-e-${index}-${criticalBranch.id}`}>
                            <span id={`cbranch-outages-to-${index}-${criticalBranch.id}`}>To: </span>
                            {o.node2}
                        </p>
                        <p id={`p-cbranch-outages-f-${index}-${criticalBranch.id}`}>
                            <span id={`cbranch-outages-elementName-${index}-${criticalBranch.id}`}>Element name: </span>
                            {o.elementName}
                        </p>
                        <p id={`p-cbranch-outages-g-${index}-${criticalBranch.id}`}>
                            <span id={`cbranch-outages-EIC-${index}-${criticalBranch.id}`}>EIC: </span>
                            {o.eic}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};
